import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getContrastColor } from '../../common/ui/getContrastColor';

interface CalendarBoxTypographyProps extends TypographyProps {
  cssCalculatedWidth?: number;
  backgroundColor: string;
  viewType?: 'month' | 'day' | 'condensed';
}

const CalendarBoxTypography = styled(Typography)<CalendarBoxTypographyProps>(
  ({ cssCalculatedWidth, backgroundColor, viewType }) => ({
    textOverflow: viewType === 'day' ? 'ellipsis' : undefined,
    overflow: viewType === 'day' ? 'hidden' : undefined,
    whiteSpace: viewType === 'day' ? 'nowrap' : 'normal',
    maxWidth: cssCalculatedWidth ? `${cssCalculatedWidth} ` : 'calc(100% - 4px)',
    color: getContrastColor(backgroundColor),
    fontWeight: 600,
    fontSize: '12px',
  }),
);

export default CalendarBoxTypography;
